<ambita-cadastre-report-cadastre-sections>
  <div class="ambita-cadastre-report__section" id="ambita-cadastre-report__cadastre-sections"
       if="{ data.sections }">
    <h4 class="ambita-cadastre-report__section-title ambita-report-h4">
      { i18n.cadastreReportCadastreSections.titleSections }
    </h4>
    <table class="ambita-cadastre-report__list">
      <thead class="ambita-cadastre-report__header">
      <tr class="ambita-cadastre-report__row">
        <th>{ i18n.cadastreReportCadastreSections.sectionCadastre }</th>
        <th>{ i18n.cadastreReportCadastreSections.sectionMunicipality }</th>
        <th>{ i18n.cadastreReportCadastreSections.sectionStreet }</th>
        <th>{ i18n.cadastreReportCadastreSections.sectionHouseNumber }</th>
        <th>{ i18n.cadastreReportCadastreSections.sectionPostalAddress }</th>
        <th>{ i18n.cadastreReportCadastreSections.sectionPurpose }</th>
        <th>{ i18n.cadastreReportCadastreSections.sectionFraction }</th>
      </tr>
      </thead>
      <tbody>
      <tr class="ambita-cadastre-report__row">
        <td class="{ ambita-clickable-cadastre: opts.hasCadastreClickHandler }" colspan="7">{ data.cadastre }</td>
      </tr>
      <tr class="ambita-cadastre-report__row" each="{ section in data.sections }">
        <td class="{ ambita-clickable-cadastre: isCadastreClickable(section.ident) }">
          { formatCadastre(section.ident) }
        </td>
        <td>{ section.municipality.municipalityName }</td>
        <td>{ section.sectionAddress.street.streetName }</td>
        <td>{ section.sectionAddress.ident.addressNumber } { section.sectionAddress.ident.letter }</td>
        <td>{ formatPostalAddress(section.sectionAddress.street) }</td>
        <td>{ section.currentSectioning.purpose.text }</td>
        <td>{ section.currentSectioning.fraction.numerator }/{ section.currentSectioning.fraction.denominator }</td>
      </tr>
      </tbody>
    </table>
  </div>
  <script>
    import './cadastreSectionsTranslations';
    import { init } from './sectionController';

    init(this);
  </script>
</ambita-cadastre-report-cadastre-sections>
